import { deviceType } from "@tm/isomorphic-utils";
import styled from "styled-components";

export const BreadcrumbNav = styled.nav`
  width: 100%;
`;

export const BreadcrumbContainer = styled.ol`
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  background: transparent;
  width: 1200px;
  margin: 0 auto;

  @media ${deviceType.mobile} {
    padding: 0 20px;
    width: auto;
    margin: 0;
  }
`;

interface BreadcrumbItemProps {
  isActive?: boolean;
}

export const BreadcrumbItem = styled.li<BreadcrumbItemProps>`
  color: #000;
  font-size: 14px;
  font-weight: 400;

  ${(props) =>
    props.isActive &&
    `
    font-weight: 500;
  `}

  @media ${deviceType.mobile} {
    font-size: 12px;
  }
`;

export const BreadcrumbLink = styled.a`
  color: #000;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:visited {
    color: #000;
  }
`;

export const BreadcrumbSeparator = styled.span`
  color: #000;
  margin: 0 8px;
  font-size: 14px;
  user-select: none;

  @media ${deviceType.mobile} {
    margin: 0 6px;
    font-size: 12px;
  }
`;
